module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn container-fluid top-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('br'), _vm._v(" "), _c('h2', [_vm._v("Welcome to the Highlight Film Test Stand Portal")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("This portal allows you to review the data, create graphs and analyze results of film tests from across multiple testing systems.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, [_c('div', {
    staticClass: "col-sm-4 text-wrapper text-right"
  }, [_c('div', [_vm._v("\n            Data allows you to select the date range to view your test results.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 img-wrapper"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "static/img/dashboard1.jpg",
      "width": "100%"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, [_c('div', {
    staticClass: "col-sm-8 img-wrapper"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "static/img/dashboard3.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-wrapper"
  }, [_c('div', [_vm._v("\n            Graphs allow you to create graphs within a specific data and time range encompassing the range of film tests\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, [_c('div', {
    staticClass: "col-sm-4 text-wrapper text-right"
  }, [_c('div', [_vm._v("\n            You can also view graphs for multiple tests of the same type in a single graph.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 img-wrapper"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "static/img/dashboard3.jpg",
      "width": "100%"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a8c0fd7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Dashboard/Dashboard.vue
// module id = 731
// module chunks = 8